const getSameLevelMaxZindex = (node) => {
  const siblings = node.parentNode.children;
  const zIndexs = [...siblings].map((item) => {
    if (
      (/el-loading/g).test(item.className)
      || (/el-dropdown/g).test(item.className)
      || (/el-popover global-tip-text-pop/g).test(item.className)
    ) {
      return 0;
    }
    const z = Number(window.getComputedStyle(item).zIndex);
    return Number.isNaN(z) ? 0 : z;
  });
  return Math.max(...zIndexs);
};

export default getSameLevelMaxZindex;
